/**
 * Utilitário de logging para o frontend que controla a saída de logs com base no ambiente
 */

// Determina se estamos em ambiente de produção
const isProduction = process.env.NODE_ENV === 'production';

/**
 * Registra um log com base no ambiente
 * @param {string} message - Mensagem a ser registrada
 * @param {Object} details - Detalhes adicionais para o log
 * @param {string} level - Nível do log (info, warn, error, security)
 * @param {boolean} showInProduction - Se true, exibe o log mesmo em produção
 */
const log = (message, details = {}, level = 'info', showInProduction = false) => {
  // Verificar se level é uma string para evitar erros
  if (typeof level !== 'string') {
    level = 'info'; // Valor padrão seguro
  }

  // Em produção, só mostra logs no console se showInProduction for true
  if (isProduction && !showInProduction) {
    return;
  }
  
  // Em desenvolvimento ou se showInProduction for true
  const prefix = `[${level.toUpperCase()}]`;
  
  switch (level) {
    case 'error':
      console.error(`${prefix} ${message}`, details);
      break;
    case 'warn':
      console.warn(`${prefix} ${message}`, details);
      break;
    case 'security':
      console.warn(`[SEGURANÇA] ${message}`, details);
      break;
    case 'info':
    default:
      console.log(`${prefix} ${message}`, details);
  }
};

/**
 * Versão segura do logger para eventos de segurança
 * Nunca mostra detalhes sensíveis em produção
 * @param {string} message - Mensagem a ser registrada
 * @param {Object} details - Detalhes adicionais para o log
 */
const securityLog = (message, details = {}) => {
  // Em produção, remover detalhes sensíveis
  if (isProduction) {
    // Versão sanitizada dos detalhes para produção
    const sanitizedDetails = {};
    log(message, sanitizedDetails, 'security', true);
  } else {
    // Em desenvolvimento, mostrar todos os detalhes
    log(message, details, 'security', true);
  }
};

export { log, securityLog, isProduction };
